import { Table, Button, Row, Col, Space, Tooltip } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import React from 'react';
import moment from 'moment';
import _ from 'lodash';

class TablaDocumentosAcuerdos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: this.props.documentos,
    };
  }

  render() {
    const columns = [
      {
        title: 'Titulo',
        dataIndex: 'nombre',
        key: 'titulo',
        render: titulo => (titulo ? titulo.toUpperCase() : '-'),
      },
      {
        title: 'Ult. Modif.',
        key: 'fechaModificacion',
        render: documento =>
          documento.fechaModificacion
            ? moment(documento.fechaModificacion).format('DD/MM/YYYY HH:mm')
            : moment(documento.fechaCreacion).format('DD/MM/YYYY HH:mm'),
      },
      {
        title: 'Estado',
        key: 'Estado',
        render: documento => (documento.estado ? documento.estado : '-'),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <Space>
            <Tooltip placement="bottom" title={'Editar'}>
              <Button
                type="primary"
                disabled={record.estado === 'CONFIRMADO' || !record.textoHtml}
                onClick={() =>
                  this.props.history.push(`/documento/editar/${record._id}`)
                }
                icon={<Icons.EditOutlined />}
              />
            </Tooltip>
            {record.pdfBase64 && (
              <Tooltip placement="bottom" title={'Descargar'}>
                <Button
                  disabled={!record.pdfBase64}
                  onClick={() =>
                    this.props.verPdf(
                      record.pdfBase64,
                      `Documento_Num_${record.nombre}_${record._id}`
                    )
                  }
                  icon={<Icons.DownloadOutlined />}
                />
              </Tooltip>
            )}
            {!(record.estado === 'CONFIRMADO') && (
              <Tooltip placement="bottom" title={'Confirmar'}>
                <Button
                  onClick={() => this.props.confirmarDocumento(record._id)}
                  loading={this.props.documentoConfirmandose === record._id}
                  icon={<Icons.CheckOutlined />}
                />
              </Tooltip>
            )}
            <Tooltip placement="bottom" title={'Enviar'}>
              <Button
                onClick={() => this.props.mostrarModalMandarEmail(record._id)}
                icon={
                  <Icons.MailOutlined
                    style={{
                      color: record.enviadoPorEmail ? '#27b504' : '#000000',
                    }}
                  />
                }
              />
            </Tooltip>
            <Button
              onClick={() => this.props.mostrarModalVisorEmail(record._id)}
              icon={<Icons.SearchOutlined />}
            />
            <Tooltip placement="bottom" title={'Eliminar'}>
              <Button
                type="danger"
                disabled={
                  (record.estado === 'CONFIRMADO' ||
                    record.allowDelete === false) &&
                  record.tipo !== 'DOCUMENTO DIGITAL'
                }
                icon={<Icons.CloseCircleOutlined />}
                onClick={() => this.props.eliminarDocumento(record._id)}
              />
            </Tooltip>
          </Space>
        ),
      },
    ];
    const { documentos } = this.props;
    return (
      <Table
        bordered
        rowKey="_id"
        columns={columns}
        size="middle"
        dataSource={documentos}
        pagination={false}
        loading={this.props.loadingTabla}
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center' }}> Documentos</h2>
            <div style={{ textAlign: 'center' }}>
              <Row>
                <Col span={6}>
                  Cantidad Total de Documentos: {this.props.total}
                </Col>
              </Row>
            </div>
          </div>
        )}
        locale={{
          emptyText: 'Sin documentos cargados.',
        }}
      />
    );
  }
}

export default TablaDocumentosAcuerdos;
